import {
  PAGE_INCREMENT,
  PAGE_DECREMENT,
  PAGE_CLICKED_NEXT_UPDATE,
  CONTROL_LOADING,
  CONTROL_EDIT_BENEFIT,
  UPDATE_UI_DATA,
  SELECT_DOCUMENT,
  RESET_SELECT_DOCUMENT,
  ADD_FILE_TO_LIST,
  REMOVE_FILE_FROM_LIST,
  CHECKBOX_STATUS_UPDATE,
  CONTROL_DECLARATION,
  UPDATE_FORM_IS_VALID,
  EDIT_ALL_INVALID_FORM,
  EDIT_UPLOAD,
  CHOOSE_BENEFIT_HEADER,
  CHOOSE_BENEFIT_DETAIL,
  COMPLETE_BENEFIT_FORM,
  REMOVE_CHOSENED_BENEFIT,
  UPDATE_UI_PROPERTY,
} from "../actions"

import * as Constants from "../../common/constants"

// Develop note
// Now the initial state is left in pristine conditions and the resulting state is just a copy of the initial state. Remember two key points for avoiding mutations in Redux:
// --use concat(), slice(), or the spread operator for arrays
// --use Object.assign() or object spread of objects

const initialUiData = {
  claimFormTitle: "Personal Accident",
  draftFolderPrefix: "PA_",
  pageNumber: 1,
  maxPageNumber: 1,
  showLoading: false,
  showDeclaration: false,
  occupationList: [],
  bankList: [],
  disablementList: [],
  // ===== UPLOAD START =====
  proofDocuments: [],
  folderName: null,
  totalFileSize: 0,
  compressedFilesize: 0,
  lockUploadDropdown: false,
  isEditUpload: false,
  hideHeaderFooter: false,
  claimUploadListModel: [],
  tempSelectedDocument: {
    documentId: 0,
    documentDesc: "Please select your document name",
  },
  // ===== UPLOAD END =====

  allProofDocuments: [],
  coverageHeaderList: [],
  chosenedBenefits: [], //Record all the user chosened benefits
  tempBenefitInfo: {}, //What is the benefit choose by user now, after confirmed will push to chosenedBenefits[]

  isComeWithChildCoverage: false,

  checkBoxStatus: {
    isAgree: false,
  },
  submittedClaimID: "",
  editBenefits: {},
  clickedNext: {
    // Number below is pageNumber
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
  },
  formIsValid: {},
}

const uiDataReducer = (state = initialUiData, action) => {
  const newState = Object.assign({}, state)

  switch (action.type) {
    case PAGE_INCREMENT:
      switch (newState.pageNumber) {
        case Constants.benefitGroupPageNumber:
          newState.pageNumber = Constants.reviewPageNumber
          break

        case Constants.benefitRequiredDocumentPageNumber:
          if (newState.isEditUpload) {
            newState.pageNumber = Constants.reviewPageNumber
            newState.isEditUpload = false
            newState.tempBenefitInfo = {}
          } else {
            newState.pageNumber += 1
          }
          break

        default:
          newState.pageNumber += 1
      }

      window.scroll(0, 0)
      if (newState.maxPageNumber < newState.pageNumber) {
        newState.maxPageNumber = newState.pageNumber
      }
      return newState

    case PAGE_DECREMENT:
      switch (newState.pageNumber) {
        case Constants.benefitGroupPageNumber:
          newState.pageNumber -= 1
          newState.claimUploadListModel = []
          newState.chosenedBenefits = []
          break
        case Constants.benefitRequiredDocumentPageNumber:
          newState.pageNumber = Constants.benefitGroupPageNumber
          newState.tempBenefitInfo = {}
          break
        case Constants.reviewPageNumber:
          if (newState.showDeclaration) {
            newState.showDeclaration = false
          } else {
            newState.pageNumber = Constants.benefitGroupPageNumber
            newState.editBenefits = {}
          }
          break
        default:
          newState.pageNumber -= 1
          break
      }

      window.scroll(0, 0)
      return newState

    case PAGE_CLICKED_NEXT_UPDATE:
      newState.clickedNext[action.currentPageNumber] = action.changes
      return newState

    case CONTROL_LOADING:
      newState.showLoading
        ? (newState.showLoading = false)
        : (newState.showLoading = true)
      return newState

    case UPDATE_UI_DATA:
      newState[action.property] = action.newData
      return newState

    case SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: action.documentId,
        documentDesc: action.documentDesc,
      }
      return newState

    case RESET_SELECT_DOCUMENT:
      newState.tempSelectedDocument = {
        documentId: 0,
        documentDesc: "Please select your document name",
      }
      return newState

    case ADD_FILE_TO_LIST:
      newState.claimUploadListModel.push({
        fileName: action.fileName,
        documentId: action.documentId,
        filePath: action.filePath,
        fileSize: action.fileSize,
        folderName: action.folderName,
        coverageDetail: action.coverageDetail,
        coverageDetailId: action.coverageDetailId,
        compressedFilesize: action.compressedFilesize,
      })

      newState.totalFileSize += action.compressedFilesize

      return newState

    case REMOVE_FILE_FROM_LIST:
      let indexOfUploadedDocumentArray = newState.claimUploadListModel
        .map(function(e) {
          return e.fileName
        })
        .indexOf(action.fileName)
      newState.claimUploadListModel.splice(indexOfUploadedDocumentArray, 1)
      newState.totalFileSize -= action.fileSize
      return newState

    case CONTROL_EDIT_BENEFIT:
      newState.editBenefits[action.formName]
        ? (newState.editBenefits[action.formName] = false)
        : (newState.editBenefits[action.formName] = true)
      return newState

    case CHECKBOX_STATUS_UPDATE:
      !newState.checkBoxStatus[action.checkboxName]
        ? (newState.checkBoxStatus[action.checkboxName] = true)
        : (newState.checkBoxStatus[action.checkboxName] = false)
      return newState

    case CONTROL_DECLARATION:
      newState.showDeclaration
        ? (newState.showDeclaration = false)
        : (newState.showDeclaration = true)
      return newState

    case UPDATE_FORM_IS_VALID:
      newState.formIsValid[action.formName] = action.status
      return newState

    case EDIT_ALL_INVALID_FORM:
      newState.editBenefits = {}

      action.formlist.forEach((formlistItem, formlistKey) => {
        newState.editBenefits[formlistItem] = true
      })
      return newState

    case EDIT_UPLOAD:
      newState.isEditUpload = true
      newState.tempBenefitInfo = {
        CoverageDetailId: action.coverageDetailId,
        CoverageDetailName: action.coverageDetailName,
      }
      newState.proofDocuments = newState.allProofDocuments.filter(
        x => x.coverageDetailId === action.coverageDetailId
      )
      newState.pageNumber = Constants.benefitRequiredDocumentPageNumber
      return newState

    case CHOOSE_BENEFIT_HEADER:
      newState.tempBenefitInfo.CoverageHeaderId = action.chosenedHeaderId
      newState.tempBenefitInfo.CoverageHeaderName = action.chosenedHeaderName

      increasePageNumber(newState)
      return newState

    case CHOOSE_BENEFIT_DETAIL:
      if (
        newState.allProofDocuments.filter(
          x =>
            x.coverageDetailId ===
            action.requiredDocumentList[0].coverageDetailId
        ).length <= 0
      ) {
        for (let doc of action.requiredDocumentList) {
          newState.allProofDocuments.push(doc)
        }
      }

      newState.proofDocuments = action.requiredDocumentList

      // // If this policy is come with child, Birth Certificate document will become mandatory
      // if (newState.isComeWithChildCoverage) {
      //   let indexOfTargetDocumentId = newState.proofDocuments
      //     .map(function(e) {
      //       return e.documentId
      //     })
      //     .indexOf(Constants.birthCertificateDocumentId)

      //   if (indexOfTargetDocumentId !== -1) {
      //     newState.proofDocuments[indexOfTargetDocumentId].mandatory = true
      //   }
      // }

      newState.tempBenefitInfo = {
        ...newState.tempBenefitInfo,
        ...action.detailInfo,
      }
      increasePageNumber(newState)
      return newState

    case COMPLETE_BENEFIT_FORM:
      // newState.clickedNext[action.coverageCode] = false
      let IsChosenBefore = false

      newState.chosenedBenefits.forEach((ChosenedItem, ChosenedKey) => {
        if (
          ChosenedItem.CoverageDetailId ===
          newState.tempBenefitInfo.CoverageDetailId
        ) {
          IsChosenBefore = true
        }
      })
      if (!IsChosenBefore) {
        newState.chosenedBenefits.push(newState.tempBenefitInfo)
      }
      newState.tempBenefitInfo = {}
      newState.pageNumber = Constants.benefitGroupPageNumber

      newState.formIsValid[action.coverageCode] = true

      return newState

    case REMOVE_CHOSENED_BENEFIT:
      const idOfBenefitNeedRemove = action.coverageDetailId

      const removedBenefit = newState.chosenedBenefits.filter(
        benefit => benefit.CoverageDetailId !== idOfBenefitNeedRemove
      )
      newState.chosenedBenefits = removedBenefit

      const removedClaimUploadListModel = newState.claimUploadListModel.filter(
        uploadedItem => uploadedItem.coverageDetailId !== idOfBenefitNeedRemove
      )
      newState.claimUploadListModel = removedClaimUploadListModel

      return newState

    case UPDATE_UI_PROPERTY:
      newState[action.propertyName] = action.propertyData
      return newState

    default:
      return newState
  }
}

export default uiDataReducer

const increasePageNumber = newState => {
  newState.pageNumber += 1

  window.scroll(0, 0)
  if (newState.maxPageNumber < newState.pageNumber) {
    newState.maxPageNumber = newState.pageNumber
  }
}
